module.exports = __webpack_public_path__ + "static/media/resultbk.e4f71b6a.png";